import { useEffect, useState } from "react";

const links = [
  { label: "Work", href: "#films" },
  { label: "Curated Projects", href: "#feature" },
  { label: "Showreel", href: "#showreel" },
  { label: "Behind", href: "#behind" },
  { label: "Contact", href: "#contact" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-black/60 border-b border-white/10"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-12 h-16 sm:h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="font-serif italic text-xl sm:text-2xl tracking-wide text-white"
        >
          V<span className="opacity-60">.</span>R
          <span className="opacity-60">.</span>
        </a>

        <ul className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <li key={l.href}>
              <a
                data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                href={l.href}
                className="hover-underline text-[11px] uppercase tracking-[0.25em] text-white/70 hover:text-white transition-colors duration-500"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <a
          data-testid="nav-contact-cta"
          href="#contact"
          className="md:hidden text-[11px] uppercase tracking-[0.25em] text-white/80 hover:text-white"
        >
          Contact
        </a>
      </div>
    </nav>
  );
};
